import styled from '@emotion/styled';
import { DARK_BLUE, GREEN } from '../colors';
import { ReactComponent as LogoJyros } from '../images/logo-jyros-white.svg';

import { useTranslation } from 'react-i18next';

const CoverLayout = styled.div`
  background: ${DARK_BLUE};
  width: 210mm;
  height: 297mm;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  position: relative;
  padding: 0;
  overflow: hidden;
`;

const CenterBlock = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 6rem;
  margin-bottom: 2rem;
`;

const LogoJyrosBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 20%;

  svg path,
  svg polygon {
    stroke-width: 0 !important;
    fill: #fff !important;
  }
`;

const JyrosSubtitle = styled.div`
  color: ${GREEN};
  font-size: 0.8rem;
  text-align: center;
  margin-left: -1rem;
  margin-right: -1rem;
  font-family: Ibrand, sans-serif;
`;

const SupportingText = styled.div`
  color: #fff;
  font-size: 1.1rem;
  font-family: Causten, sans-serif;
  text-align: left;
  margin: 2.5rem 0 2.5rem 0;
  max-width: 700px;
`;

const InitiativeBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 2.5rem auto;
  max-width: 700px;
`;

const InitiativeTitle = styled.div`
  display: flex;
  color: #fff;
  font-size: 1.5rem;
  font-family: Ibrand, sans-serif;
  font-weight: 700;
  text-align: left;
  margin-bottom: 1rem;
  align-items: flex-start;
  gap: 0.7rem;
  justify-content: flex-start;
`;

const Chevron = styled.span`
  color: #fff;
  font-size: 2.2rem;
  font-weight: bold;
  margin-right: 0.5rem;
  line-height: 1;
`;

const InitiativeDescription = styled.div`
  color: #fff;
  font-size: 1.1rem;
  font-family: Causten, sans-serif;
  text-align: left;
  margin-bottom: 2.5rem;
`;

const PartnersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2.5rem;
  width: 100%;
  margin: 0 auto 3rem auto;
`;

const PartnerLogo = styled.div`
  height: 100px;
  display: flex;
  align-items: center;
  > img {
    height: 100%;
  }
`;

const BackCover = () => {
  const { t } = useTranslation();
  const jyrosSubtitle = t('project:pdf.backCover.jyrosSubtitle');
  const initiativeTitle = t('project:pdf.backCover.initiativeTitle');
  const supportingText = t('project:pdf.backCover.supportingText');
  const initiativeDescription = t(
    'project:pdf.backCover.initiativeDescription',
  );

  return (
    <CoverLayout id="back-cover">
      <CenterBlock>
        <LogoJyrosBlock>
          <LogoJyros />
          <JyrosSubtitle>{jyrosSubtitle}</JyrosSubtitle>
        </LogoJyrosBlock>
        <SupportingText>{supportingText}</SupportingText>
        <InitiativeBlock>
          <InitiativeTitle>
            <Chevron>›</Chevron>
            {initiativeTitle}
          </InitiativeTitle>
          <InitiativeDescription>{initiativeDescription}</InitiativeDescription>
        </InitiativeBlock>
        <PartnersRow>
          <PartnerLogo>
            <img src="/Logo ARA.png" alt="Logo région" />
          </PartnerLogo>
          <PartnerLogo>
            <img
              src="/Logo caisse des dépots.png"
              alt="Logo caisse des dépots"
            />
          </PartnerLogo>
          <PartnerLogo>
            <img src="/France 2030.png" alt="Logo France 2030" />
          </PartnerLogo>
        </PartnersRow>
        <PartnersRow>
          <PartnerLogo>
            <img src="/Logo consortium.png" alt="Logo consortium" />
          </PartnerLogo>
          <PartnerLogo>
            <img src="/Logo CNC.png" alt="Logo CNC" />
          </PartnerLogo>
        </PartnersRow>
      </CenterBlock>
    </CoverLayout>
  );
};

export default BackCover;
